module.exports = __webpack_public_path__ + "img/lw-exp-1.1cc79583.jpg";